import { render, staticRenderFns } from "./RecurringRemarkListSideMenu.vue?vue&type=template&id=495c26bc&scoped=true"
import script from "./RecurringRemarkListSideMenu.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./RecurringRemarkListSideMenu.vue?vue&type=style&index=0&id=495c26bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c26bc",
  null
  
)

export default component.exports